import { LineClampElement, ScreenBreakpointWidth, TileTypeKeys, tileTypes } from './tile.types';
import { classNameBuilder } from '../classNameBuilder';
import { handlePopup } from '../openInPopup';
import key from 'weak-key';
import { Tile } from '../../components/ContentElementsGdds/Tiles/tleb1-tiles-props';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';

export function getTileLineClampClass(type: TileTypeKeys, variant: LineClampElement) {
  if (!tileTypes[type]) return undefined;

  const tile = tileTypes[type];

  if (!tile.lineClamps) return undefined;

  const size = tile.lineClamps['50percent'];
  if (!size) return undefined;

  const cssClasses = Object.entries(size).map(([key, value]) => {
    const breakpointSize = key as ScreenBreakpointWidth;
    const lineClampAmount = value[variant] as number;

    if (breakpointSize === '0') return `line-clamp-${lineClampAmount}`;

    return `line-clamp-${breakpointSize}-${lineClampAmount}`;
  });

  if (!cssClasses.length) return undefined;

  return classNameBuilder(...cssClasses);
}

export const handleTileLink = (
  event: MouseEvent,
  tile: Tile,
  router: AppRouterInstance,
  trackOnClick: (item: Tile) => void,
) => {
  if (!tile.link) return;

  event.preventDefault();
  event.stopPropagation();

  if (tile.link.window === '_self') {
    router.push(tile.link.target!);
  }

  if (tile.link.window === '_blank' || tile.link.window === 'default') {
    window.open(tile.link.target, tile.link.window)?.focus();
  }

  if (tile.link.window === '_popup') {
    handlePopup(tile.link, key(tile.link));
  }
  trackOnClick(tile);
};
